'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _find3 = require('lodash/find');

var _find4 = _interopRequireDefault(_find3);

var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reactI18next = require('react-i18next');

var _quicksend = require('redux/modules/quicksend');

var quickSendActions = _interopRequireWildcard(_quicksend);

var _toastr = require('helpers/toastr');

var _toastr2 = _interopRequireDefault(_toastr);

var _components = require('components');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _quicksend2 = require('selectors/quicksend');

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _QuickSendForwardButton = require('./QuickSendForwardButton');

var _QuickSendForwardButton2 = _interopRequireDefault(_QuickSendForwardButton);

var _projects = require('helpers/projects');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var styles = require('./QuickSendActions.scss');

var QuickSendActions = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    qsDeleteLoading: state.quicksend.qsDeleteLoading,
    qsList: (0, _quicksend2.processQuickSends)(state),
    qsListLoading: state.quicksend.qsListLoading,
    user: state.auth.user
  };
}, (0, _extends3.default)({}, quickSendActions)), _dec2 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(QuickSendActions, _Component);

  function QuickSendActions() {
    (0, _classCallCheck3.default)(this, QuickSendActions);
    return (0, _possibleConstructorReturn3.default)(this, (QuickSendActions.__proto__ || (0, _getPrototypeOf2.default)(QuickSendActions)).apply(this, arguments));
  }

  (0, _createClass3.default)(QuickSendActions, [{
    key: 'onForward',
    value: function onForward() {
      var _props = this.props,
          loadBox = _props.loadBox,
          boxType = _props.boxType;

      loadBox(boxType);
    }
  }, {
    key: 'refresh',
    value: function refresh() {
      var _props2 = this.props,
          loadBox = _props2.loadBox,
          boxType = _props2.boxType,
          onRefresh = _props2.onRefresh,
          qsListLoading = _props2.qsListLoading;

      if (!qsListLoading) {
        loadBox(boxType).promise.then(onRefresh);
      }
    }
  }, {
    key: 'remove',
    value: function remove() {
      var _props3 = this.props,
          qsId = _props3.qsId,
          qsDelete = _props3.qsDelete,
          t = _props3.t,
          onDelete = _props3.onDelete,
          qsDeleteLoading = _props3.qsDeleteLoading;


      if (qsDeleteLoading) {
        return false;
      }

      var toastrConfirmOptions = {
        onOk: function onOk() {
          return qsDelete(qsId).promise.then(onDelete);
        }
      };
      _toastr2.default.confirm(t('Are you sure you want to delete this Quick Send?'), toastrConfirmOptions);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props4 = this.props,
          t = _props4.t,
          qsDeleteLoading = _props4.qsDeleteLoading,
          qsListLoading = _props4.qsListLoading,
          qsList = _props4.qsList,
          qsId = _props4.qsId,
          className = _props4.className,
          toggleBoxView = _props4.toggleBoxView,
          user = _props4.user,
          boxType = _props4.boxType;

      var qsItem = (0, _find4.default)(qsList, { projectId: qsId }) || {};
      var isSentType = boxType === _projects.quickSendBox.sent;

      return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)(styles.headLine, className) },
        _react2.default.createElement(
          'span',
          null,
          _react2.default.createElement(
            'span',
            { className: (0, _classnames2.default)(styles.button, 'actionBackButton'), onClick: function onClick() {
                return toggleBoxView('box');
              } },
            _react2.default.createElement('i', { className: 'icon-arrow-back' })
          )
        ),
        _react2.default.createElement(
          'span',
          { className: styles.actionButtons },
          isSentType && _react2.default.createElement(_QuickSendForwardButton2.default, {
            id: qsId,
            data: qsItem,
            className: styles.button,
            iconClass: 'margin-right-5',
            onForward: this.onForward
          }),
          _react2.default.createElement(
            'button',
            { className: styles.button, onClick: this.refresh },
            _react2.default.createElement('i', { className: (0, _classnames2.default)('icon-sync', { 'spin reverse': qsListLoading }) }),
            t('Refresh')
          ),
          _react2.default.createElement(
            'button',
            {
              className: styles.button,
              disabled: !user || qsItem.owId !== user.userId,
              onClick: this.remove
            },
            _react2.default.createElement(
              'i',
              { className: 'icon-delete margin-right-5 pos-rel' },
              qsDeleteLoading && _react2.default.createElement(_components.Loader, { mask: true, small: true })
            ),
            t('Delete')
          )
        )
      );
    }
  }]);
  return QuickSendActions;
}(_react.Component), _class3.propTypes = {
  boxType: _propTypes2.default.string,
  className: _propTypes2.default.string,
  loadBox: _propTypes2.default.func,
  onDelete: _propTypes2.default.func,
  onRefresh: _propTypes2.default.func,
  qsDelete: _propTypes2.default.func,
  qsDeleteLoading: _propTypes2.default.bool,
  qsId: _propTypes2.default.number,
  qsList: _propTypes2.default.array,
  qsListLoading: _propTypes2.default.bool,
  t: _propTypes2.default.func,
  toggleBoxView: _propTypes2.default.func,
  user: _propTypes2.default.object
}, _class3.defaultProps = {
  onDelete: function onDelete() {},
  onRefresh: function onRefresh() {}
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'onForward', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onForward'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'refresh', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'refresh'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'remove', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'remove'), _class2.prototype)), _class2)) || _class) || _class);
exports.default = QuickSendActions;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/QuickSend/QuickSendActions.js
// module id = 2070
// module chunks = 1